module.exports = __webpack_public_path__ + "static/media/login-step-2.55d1bc8b.png";